/**
 * Collection Product Reorder - Out of Stock Last
 * Reordena os produtos na grid da coleção, movendo os sem estoque para o final
 */

(function () {
  'use strict';

  const selectors = {
    productGridPrimary: '#AjaxinateLoop',
    productGridFallback: '[data-collection-products] .grid',
    productItem: '[data-product-block]',
    promoItem: '[data-promo]'
  };

  const classes = {
    soldOut: 'soldout'
  };

  /**
   * Reordena os produtos movendo os sem estoque para o final
   * Mantém os promos em suas posições originais relativas
   */
  function reorderOutOfStock() {
    // Tenta o seletor primário (infinite scroll) ou usa o fallback
    const grid = document.querySelector(selectors.productGridPrimary) || document.querySelector(selectors.productGridFallback);
    if (!grid) return;

    const allItems = Array.from(grid.children);
    const products = allItems.filter(item => item.matches(selectors.productItem) && !item.matches(selectors.promoItem));
    const promos = allItems.filter(item => item.matches(selectors.promoItem));

    // Separa produtos em estoque dos esgotados
    const inStock = products.filter(product => !product.classList.contains(classes.soldOut));
    const outOfStock = products.filter(product => product.classList.contains(classes.soldOut));

    // Se não há produtos esgotados, não precisa reordenar
    if (outOfStock.length === 0) return;

    // Remove todos os produtos (mantém promos)
    products.forEach(product => product.remove());

    // Adiciona de volta: primeiro em estoque, depois esgotados
    const reorderedProducts = [...inStock, ...outOfStock];

    // Insere os produtos de volta na grid
    // Promos já estão na grid, então inserimos produtos entre/ao redor deles
    if (promos.length === 0) {
      // Sem promos, apenas adiciona todos
      reorderedProducts.forEach(product => grid.appendChild(product));
    } else {
      // Com promos, adiciona produtos ao final (após os promos)
      reorderedProducts.forEach(product => grid.appendChild(product));
    }
  }

  /**
   * Inicializa a reordenação quando DOM estiver pronto
   */
  function init() {
    // Reordena na carga inicial
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        // Pequeno delay para garantir que todos os elementos estejam renderizados
        setTimeout(reorderOutOfStock, 100);
      });
    } else {
      setTimeout(reorderOutOfStock, 100);
    }
  }

  // Expõe a função globalmente para uso no callback do Ajaxinate
  window.reorderOutOfStock = reorderOutOfStock;

  // Inicializa
  init();
})();
